import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { TranslocoService, translate } from '@jsverse/transloco';
import { Subject, combineLatest, forkJoin } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { CachedService } from 'src/app/core/service/common/cached.service';
import { MapService } from 'src/app/core/service/api/map.service';
import { PubsubService } from 'src/app/core/service/api/pubsub.service';
import { IntegrationsService } from 'src/app/core/service/integrations.service';
import { arcgisTypeDefine, getArcGiUniqueResponce } from 'src/app/core/util/integration';
import { IntegrationsModalComponent } from 'src/app/core/util/integration/integrations-modal';
import { modalConfig, ModalEnum } from 'src/app/core/util/modalConfig';
import { ProjectConfigsService } from '../../../../akita/project-configs/state/project-configs.service';
import { showFeedbackError, showFeedbackSaved } from '../../../../core/util/notification';
import { Globals } from '../../../../globals';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

export interface SyncLayerUiState {
  creating?: boolean;
}

@Component({
  selector: 'app-integrations-modal-arcgis',
  templateUrl: './integrations-modal-arcgis.component.html',
  styleUrls: ['./integrations-modal-arcgis.component.sass']
})
export class IntegrationsModalArcgisComponent extends IntegrationsModalComponent implements OnInit {
  private serviceGroup: string = 'integration';
  public isProcess: boolean = false;
  public isProcessLayers: boolean = false;
  public arhgisenable:boolean=false;
  public featureLayers:any={};
  public layerEntity: any[] = [];
  public layerFeatures:any[]=[];
  public enableLayers:any={};
  public updatedLayers: any = { featurelayers: [], layers: [] };
  public errorMessage:boolean=false;
  public isSpinning:boolean=false;
  public hasWritePermission: boolean = false;
  public retryButton:boolean=false;
  public connectedDisable:boolean=false;
  public archisToggleSelection:string='arcgis';
  public enterpriseField:boolean=false;
  public enterpriseURL:string='https://assetstest.duravermeer.nl/portal/sharing/oauth2/authorize';
  public clientid:string='';
  public clientsecret:string='';
  public connecting: boolean = false;
  public togglerDisabler:boolean=false;
  public broadcastWaitMessage=translate('settings.arcgis.broadcasting_wait');
  public activeArcGis:string='arcgis'
  public isArcgisSecret: boolean = false;
  private secretDebouncer: Subject<any> = new Subject();
  @ViewChild('form_integration', { static: false }) form_integration: FormGroup;
  public level:any='';
  public projectname:any;
  public arcGisLayers: any[] = [];
  public arcGisToken: string;
  public count: number = 0;

  public syncLayerState: Record<string, SyncLayerUiState> = {};
  public syncLayersList: Array<{
    name: string;
    labelKey: string;
    error: string | null;
    layer_info: { name: string; url: string; arcgis_link: string } | null;
    creating: boolean;
  }> = [];
  private pendingLayerKey: string | null = null;
  public hasServiceError: boolean = false;
  public hasAnySyncLayerError: boolean = false;
  public recreatingService: boolean = false;

  public arcgisUsers: any[] = [];
  public arcgisUsersForSelect: any[] = [];
  public selectedArcGisUsers: any[] = [];
  public integratedArcGisUserIds: number[] = [];
  public isProcessArcGisUsers: boolean = false;

 constructor(
   private cd: ChangeDetectorRef,
   private location: Location,
   public _rout:Router,
   public pubsub: PubsubService,
   @Inject(MAT_DIALOG_DATA) public data: any,
   public dialogRef: MatDialogRef<any>,
   public globals: Globals,
   public _projectConfigsService: ProjectConfigsService,
   private _integrationsService: IntegrationsService,
   private _mapServices: MapService,
   private _dialog: MatDialog,
   private _transloco: TranslocoService,
   private _cachedService: CachedService
   ) {
    super(globals, _projectConfigsService);
  }
  ngOnInit() {
    if(this._rout.url.includes('beheer')){
      this.level='company';
      this.projectname = this._rout.url.split("/")[2];
    }
    this.secretDebouncer.pipe(
      debounceTime(300)
    ).subscribe((value) => {
      if (value) {
        this.setEnterpriseSecret(value);
      } else {
        this.setEnterpriseSecret('');
      }
    });
    if(this._integrationsService.layers==undefined){
      this._integrationsService.layers=this._integrationsService.layerBroadcasting.subscribe((res)=>{
        this.afterBroadCastingFeatureLayers(res)
        this._integrationsService.layers=undefined;
      });
    }
    this.connectedDisable=true;
    this.updatedLayers.featurelayers = [];
    this.updatedLayers.layers = [];
    
    this.getConfig(this.serviceGroup, () => {
      this.applyArcgisStateFromConfig();
      this.arcgisValidator();
      if (this.arhgisenable) {
        this.loadArcGisUserAccesses();
      }
      this.onLoadFeatureLayers();
      this.cd.detectChanges();
    });
  }

  /** Load project users and which have ArcGIS enabled; set integrated = project connector(s). */
  public loadArcGisUserAccesses(): void {
    this.isProcessArcGisUsers = true;
    forkJoin([
      this._cachedService.getUsers(),
      this._cachedService.getGlobalUsers(),
      this._projectConfigsService.getIntegrationEnabledUserconfigs()
    ]).subscribe({
      next: ([projectUsers, globalUsers, integrationEnabledList]) => {
        this.arcgisUsers = projectUsers || [];

        const list = (integrationEnabledList || []) as any[];
        const enabledIds = new Set<number>();
        const useEnterprise = this.archisToggleSelection === 'arcgis_enterprise';
        list.forEach((uc: any) => {
          const uid = uc.users_id ?? uc.users?.id;
          if (uid == null) return;

          const enabled = useEnterprise ? !!uc.arcgis_enterprise_enabled : !!uc.arcgis_enabled;
          if (enabled) {
            enabledIds.add(Number(uid));
          }
        });

        this.integratedArcGisUserIds = this.computeIntegratedProjectUserIds(
          this.arcgisUsers,
          globalUsers || []
        );
        const mustSelectIds = new Set<number>([
          ...Array.from(enabledIds.values()),
          ...this.integratedArcGisUserIds,
        ]);

        this.arcgisUsersForSelect = this.arcgisUsers.map((u: any) => ({
          ...u,
          is_disabled: this.integratedArcGisUserIds.includes(u.id),
        }));

        const integratedSet = new Set(this.integratedArcGisUserIds);
        this.selectedArcGisUsers = this.arcgisUsersForSelect
          .filter((u: any) => mustSelectIds.has(u.id))
          .sort((a: any, b: any) => {
            const aIntegrated = integratedSet.has(a.id);
            const bIntegrated = integratedSet.has(b.id);
            if (aIntegrated === bIntegrated) return 0;
            return aIntegrated ? -1 : 1;
          });
        this.isProcessArcGisUsers = false;
        this.cd.detectChanges();
      },
      error: () => {
        this.arcgisUsers = [];
        this.arcgisUsersForSelect = [];
        this.selectedArcGisUsers = [];
        this.integratedArcGisUserIds = [];
        this.isProcessArcGisUsers = false;
        this.cd.detectChanges();
      }
    });
  }

  /**
   * Project connector user id(s) (project user IDs), resolved from project configs and global users:
   * services.integration.arcgis.user / arcgis_enterprise.user store global user IDs.
   * We match those global users by email to the project users to get project user IDs.
   */
  private computeIntegratedProjectUserIds(projectUsers: any[], globalUsers: any[]): number[] {
    if (!projectUsers || !projectUsers.length || !globalUsers || !globalUsers.length) {
      return [];
    }

    const connectorGlobalIds: number[] = [];
    const arcgisGlobal = this.globals.projectConfigs?.['services.integration.arcgis.user'];
    const enterpriseGlobal = this.globals.projectConfigs?.['services.integration.arcgis_enterprise.user'];

    if (arcgisGlobal != null && arcgisGlobal !== '' && arcgisGlobal !== '0') {
      connectorGlobalIds.push(Number(arcgisGlobal));
    }
    if (enterpriseGlobal != null && enterpriseGlobal !== '' && enterpriseGlobal !== '0') {
      connectorGlobalIds.push(Number(enterpriseGlobal));
    }

    if (!connectorGlobalIds.length) {
      return [];
    }

    const globalById = new Map<number, any>();
    (globalUsers || []).forEach((g: any) => {
      if (g && g.id != null) {
        globalById.set(Number(g.id), g);
      }
    });

    const projectByEmail = new Map<string, any>();
    (projectUsers || []).forEach((u: any) => {
      if (u && typeof u.email === 'string') {
        projectByEmail.set(u.email.toLowerCase(), u);
      }
    });

    const idSet = new Set<number>();
    connectorGlobalIds.forEach((globalId) => {
      const g = globalById.get(globalId);
      const email = g?.email && typeof g.email === 'string' ? g.email.toLowerCase() : null;
      if (!email) {
        return;
      }
      const projectUser = projectByEmail.get(email);
      if (projectUser && projectUser.id != null) {
        idSet.add(Number(projectUser.id));
      }
    });

    return Array.from(idSet.values());
  }

  public onArcGisUsersChange(selected: any[]): void {
    const integratedSet = new Set(this.integratedArcGisUserIds);
    const merged = [...selected];
    this.arcgisUsersForSelect.forEach((u: any) => {
      if (integratedSet.has(u.id) && !merged.some((s: any) => s.id === u.id)) merged.push(u);
    });
    this.selectedArcGisUsers = merged.sort((a: any, b: any) => {
      const aIntegrated = integratedSet.has(a.id);
      const bIntegrated = integratedSet.has(b.id);
      if (aIntegrated === bIntegrated) return 0;
      return aIntegrated ? -1 : 1;
    });
    const selectedIds = new Set(merged.map((u: any) => u.id));
    const useEnterprise = this.archisToggleSelection === 'arcgis_enterprise';
    const payload = {
      userconfigs: this.arcgisUsers.map((u: any) => {
        const item: { user_id: number; arcgis_enabled?: boolean; arcgis_enterprise_enabled?: boolean } = { user_id: u.id };
        if (useEnterprise) {
          item.arcgis_enterprise_enabled = selectedIds.has(u.id);
        } else {
          item.arcgis_enabled = selectedIds.has(u.id);
        }
        return item;
      })
    };

    this._projectConfigsService.putUserconfigsBatch(payload).subscribe({
      next: () => {
        showFeedbackSaved();
      },
      error: (err) => showFeedbackError(err),
    });
  }

  public trackByUserId(_index: number, user: { id: number }): number {
    return user.id;
  }

  //on load arcgis layers
  public onLoadFeatureLayers(){
    if(this.arhgisenable){
      this.isProcess=true;
      this.isProcessLayers=true;
      if(!this.globals.featuresLayers){
          this.getFeaturesLayersFunction();
      }else{
        this.loadBroadcastingMessage();
        this.featureLayers=this.globals.featuresLayers;
        this.layerEntity=this.featureLayers.layers;
        this.connectedDisable=false;
        this.isProcess=false;
        if(this.featureLayers.featurelayers){
          this.layerFeatures=this.featureLayers.featurelayers;
          this.updatedLayers.featurelayers = this.layerFeatures.filter((item) => {
            return item.enabled==1;
          });
          this.isProcessLayers=false;
          this.retryButton=false;
        }else{
          this.broadCastingProcessCheck();
        }
        this.updatedLayers.layers = this.layerEntity.filter((item) => {
          return item.value==1;
        });
        this.updateSyncLayersForDisplay();
      }
      this.cd.detectChanges();
    }
  }
  public getFeaturesLayersFunction(){
    this._projectConfigsService.getFeatureLayers(this.archisToggleSelection).subscribe((response: any) => {
      const previouslySelectedNames = (this.updatedLayers?.layers ?? []).map((l: any) => l.name);
      this.globals.featureLayersProcessID = response.feature_layer_process_id;
      this.globals.featuresLayers = response;
      this.featureLayers = response;
      this.layerEntity = this.featureLayers?.layers ?? [];
      this.layerEntity.forEach((layer: any) => {
        layer.value = previouslySelectedNames.indexOf(layer.name) !== -1 ? 1 : (layer.value ?? 0);
      });
      this.connectedDisable = false;
      this.isProcess = false;
      if (this.globals.projectConfigs) {
        const serviceErrorKey = `services.integration.${this.activeArcGis}.service.error`;
        this.globals.projectConfigs[serviceErrorKey] = this.featureLayers?.service_error ?? '';
      }
      this.updatedLayers.layers = this.layerEntity.filter((item: any) => item.value === 1);
      this.updateSyncLayersForDisplay();
      this.hasServiceError = !!(this.featureLayers?.service_error && String(this.featureLayers.service_error).trim());
      this.loadBroadcastingMessage();
      this.cd.detectChanges();
    }, (error) => {
      this.errorMessage=true;
      this.isProcess=false;
      this.connectedDisable=true;
      this.globals.projectConfigs['services.integration.arcgis.connection_error']=true;
      this.cd.detectChanges();
      showFeedbackError(error);
    });
  }
  public close(): void {
    this.pubsub.closeModal(this.dialogRef);
    this.pubsub.resetHistory();
  }
  arcgicRediect(){
    if(this.arhgisenable){
      this.location.replaceState(`/${this.level}` == 'company' ? 'beheer/' : `${ this.level}` == 'company' ? this.projectname : `${this.globals.projectCode}/instellingen/integraties`);
      this.arhgisenable=false;
      this.setConfig(this.serviceGroup, () => {
        this.dialogRef.close();
        showFeedbackSaved();
      });
      this.arcgisCongigsLogs();
    }
    else{
      const expiration=-1;
      if(this.archisToggleSelection=='arcgis_enterprise'){
        if (this.enterpriseConnectDisabled) return;
        this.connecting = true;
        localStorage.setItem('redirectType', 'arcgis_enterprise');
        localStorage.setItem('state', this.level == 'company' ? this.projectname : this.globals.projectCode);
        this._projectConfigsService.update('arcgis_enterprise', this.globals.projectConfigs).subscribe({
          next: () => {
            window.location.href = `${this.globals.projectConfigs['services.integration.arcgis_enterprise.url']}/portal/sharing/oauth2/authorize?client_id=${this.globals.projectConfigs['services.integration.arcgis_enterprise.client_id']}&response_type=code&expiration=${expiration}&redirect_uri=${this._projectConfigsService.arcgisRedirectUri()}`;
          },
          error: (err) => {
            this.connecting = false;
            this.cd.detectChanges();
            showFeedbackError(err);
          }
        });
      }else{
        localStorage.setItem('redirectType', 'arcgis');
        localStorage.setItem('state', this.level == 'company' ? this.projectname : this.globals.projectCode);
        window.location.href =`https://www.arcgis.com/sharing/rest/oauth2/authorize?client_id=${this.globals.clientId}&response_type=code&expiration=${expiration}&redirect_uri=${this._projectConfigsService.arcgisRedirectUri()}`;
      }
    }
  }

  public onSecretChange(event: any): void {
    this.secretDebouncer.next(event.target.value);
  }

  public setEnterpriseSecret(secret: string): void {
    // remove previous secret
    if (!this.isArcgisSecret && this.globals.projectConfigs['services.integration.arcgis_enterprise.client_secret']) {
      this.isArcgisSecret = true;
      this.globals.projectConfigs['services.integration.arcgis_enterprise.client_secret'] = '';
      this.setConfig(this.serviceGroup);
    } else {
      // update new secret
      this.globals.projectConfigs['services.integration.arcgis_enterprise.client_secret'] = secret;
      this.setConfig(this.serviceGroup);
    }
    this.cd.detectChanges();
  }
  public saveupdateFunction(layers){
    this.showAllInGlobel(layers);
    this._projectConfigsService.updateFeatureLayers(layers,this.archisToggleSelection)
    .pipe(
      tap(async (res: any) => {
        await this.integrationSetup();
        showFeedbackSaved();
      })
    ).subscribe();
  }
  public async updateLayers() {
    await this.onResetLayerSelection();
    this.updatedLayers.featurelayers.map((key)=>{
      key['enabled']=1;
    });
    this.updatedLayers.layers.map((key)=>{
      key['value']=1;
    });
    await this.saveupdateFunction(this.updatedLayers);
    this.updateSyncLayersForDisplay();
  }
  get enterpriseConnectDisabled(): boolean {
    if (this.archisToggleSelection !== 'arcgis_enterprise') return false;
    const url = this.globals.projectConfigs?.['services.integration.arcgis_enterprise.url']?.trim();
    const clientId = this.globals.projectConfigs?.['services.integration.arcgis_enterprise.client_id']?.trim();
    const clientSecret = this.globals.projectConfigs?.['services.integration.arcgis_enterprise.client_secret']?.trim();
    const urlValid = url && /^https?:\/\/.+/.test(url);
    return !(urlValid && clientId && clientSecret);
  }
  public modelChangedUrl(_data: string): void { }
  public toggle(){
    if(this.archisToggleSelection=='arcgis_enterprise'){
      this.enterpriseField=true;
    }else{
      this.enterpriseField=false;
    }
  }

  /** Names of integrated users (for chipDisabler: hide X and disable uncheck in dropdown). */
  public get integratedArcGisUserNames(): string[] {
    return this.arcgisUsersForSelect
      .filter((u: any) => this.integratedArcGisUserIds.includes(u.id))
      .map((u: any) => u.name || '');
  }
  public arcgisCongigsLogs(){
    // Argis Setup
    this.globals.projectConfigs['services.integration.arcgis.configlevel']='open';
    this.globals.projectConfigs['services.integration.arcgis.user']='0';
    if(this.globals.user){
      if(this.globals.user.configs){
        this.globals.user.configs.arcgis_enabled=0;
      }
    }
    this.globals.projectConfigs['services.integration.arcgis.enabled']=false;
    this.globals.projectConfigs['services.integration.arcgis.connection_error']=false;
    // Argis Setup End
    // Arcgis Enterprise Setup
    this.globals.projectConfigs['services.integration.arcgis_enterprise.configlevel']='open';
    this.globals.projectConfigs['services.integration.arcgis_enterprise.user']='0';
    if(this.globals.user){
      if(this.globals.user.configs){
        this.globals.user.configs.arcgis_enterprise_enabled=0;
      }
    }
    this.globals.projectConfigs['services.integration.arcgis_enterprise.enabled']=false;
    this.globals.projectConfigs['services.integration.arcgis_enterprise.connection_error']=false;
    // Arcgis Enterprise Setup End
  }
  public arcgisValidator(){
    if(this.globals.projectConfigs['services.integration.arcgis_enterprise.enabled']){
      this.togglerDisabler=true;
      this.enterpriseField=true;
      this.archisToggleSelection='arcgis_enterprise';
    }else if(this.globals.projectConfigs['services.integration.arcgis.enabled']){
      this.togglerDisabler=true;
      this.enterpriseField=false;
      this.archisToggleSelection='arcgis';
    }else{
      this.togglerDisabler=false;
      this.enterpriseField = (this.archisToggleSelection === 'arcgis_enterprise');
    }
  }

  /** Updates connection/error/privilege state from current globals.projectConfigs. */
  private applyArcgisStateFromConfig(): void {
    const privileges =
      this.globals.projectConfigs['services.integration.arcgis.enabled']
        ? this.globals.projectConfigs['services.integration.arcgis.privileges']
        : this.globals.projectConfigs['services.integration.arcgis_enterprise.enabled']
        ? this.globals.projectConfigs['services.integration.arcgis_enterprise.privileges']
        : null;
    this.hasWritePermission = privileges?.includes("portal:publisher:publishFeatures") ?? false;
    this.arhgisenable = !!(this.globals.projectConfigs['services.integration.arcgis.enabled'] || this.globals.projectConfigs['services.integration.arcgis_enterprise.enabled']);
    this.errorMessage = !!(this.globals.projectConfigs['services.integration.arcgis.connection_error'] || this.globals.projectConfigs['services.integration.arcgis_enterprise.connection_error']);
  }

  public removeSpace(layername){
    return layername.replace(/\s/g, '');
  }
  //broad casting api
  public afterBroadCastingFeatureLayers(status){
    if(status=='completed'){
      this.onLoadFeatureLayers();
      this.retryButton=false;
      return;
    }
    this.broadCastingProcessCheck();
  }
  //process check
  public broadCastingProcessCheck(){
    this._projectConfigsService.broadcastingProcess(this.globals.featureLayersProcessID)
      .pipe(
        tap((res:any)=>{
          if(!res.ok){
            this.activeArcGis=arcgisTypeDefine(this.globals);
              this._projectConfigsService.getBroadcastingFeatureLayers(this.activeArcGis)
              .pipe(
                tap(layers=>{
                  this.globals.featuresLayers.featurelayers=getArcGiUniqueResponce(layers);
                  this.cd.detectChanges();
                  this.globals.features_Exist = true;
                  if(this.globals.features_Exist){
                    if(!this.globals.featuresLayers.featurelayers){
                      this.retryButton=true;
                      this.isProcessLayers=false;
                    }else{
                      this.onLoadFeatureLayers();
                      this.isProcessLayers=false;
                      this.cd.detectChanges();
                    }
                  }else{
                    this.count = this.count + 1;
                    if(this.count === 10){
                      this.retryButton=true;
                      this.isProcessLayers=false;
                      return
                    }
                    this.broadCastingProcessCheck();
                  }
                })
            ).subscribe();

          }else{
            setTimeout(() => {
              this.broadCastingProcessCheck();
            }, 5000);
          }
        })
      ).subscribe();
  }
  //on retry
  public onRetry(){
    if(this.arhgisenable && !this.errorMessage){
      this.retryButton=false;
      this.isProcessLayers=true;
      this.getFeaturesLayersFunction();
    }
  }
  //after 10 second load message
  public loadBroadcastingMessage(): void{
    if(!this.globals.featuresLayers.featurelayers){
      setTimeout(() => {
        this.broadcastWaitMessage=translate('settings.arcgis.broadcasting_wait_late');
      }, 10000);
    }
  }
  //show all layers logic
  public showAllInGlobel(layers){
    this.globals.featuresLayers.featurelayers.forEach(items => {
      if(layers.featurelayers){
        if(layers.featurelayers.length){
          layers.featurelayers.forEach(obj => {
            if(obj.id==items.id){
              items.enabled=obj.enabled;
            }
          });
        }else{
          items.enabled=0;
        }
      }else{
        items.enabled=0;
      }
    });
  }
  /*
    Integration ArGis Reset Layers Selection
  */
  public onResetLayerSelection(): void{
    this.globals.featuresLayers.featurelayers.forEach(obj1 => {
      const matchingObj = this.updatedLayers.featurelayers.find(obj2 => obj2.id === obj1.id);
      obj1.enabled = matchingObj ? 1 : 0;
    });
    this.globals.featuresLayers.layers.forEach(obj1 => {
      const matchingObj = this.updatedLayers.featurelayers.find(obj2 => obj2.id === obj1.id);
      obj1.value = matchingObj ? 1 : 0;
    });
  }
  /*
    Integration ArGis MainLayers
  */
  public integrationSetup(): void {
    this.activeArcGis=arcgisTypeDefine(this.globals);
    combineLatest([
      this._projectConfigsService.getEnableFeatureLayers(this.activeArcGis),
      this._projectConfigsService.getFreshToken(this.activeArcGis)
    ])
    .pipe(
      tap(async ([layers, arcgis]) => {
        this.setArcGisSubLayers(layers, arcgis);
      })
    ).subscribe();
  }
  /*
    ArcGis Layers Into Sub Layers
  */
  public async setArcGisSubLayers(layers: any, arcgis: any): Promise<void> {
    this.arcGisLayers = [];
    layers.forEach(layer => {
      this._mapServices.getArcGisSubLayers(layer.url, arcgis.token)
      .pipe(
        tap(async (res: any) => {
          if(res && res.length) {
            res.forEach(item => {
              let foundObject = null;
              if(layer.metadata){
                if(layer.metadata.length) {
                  foundObject = layer.metadata.find(data => data.layerId === item.id);
                }
              }
              this.arcGisLayers.push({
                name: layer.name,
                main_layer_id: layer.id,
                layer_name: item.name,
                layer_id: item.id,
                type: item.type,
                geometry_type: item.geometryType,
                url: layer.url,
                owner: layer.owner,
                enabled: layer.enabled,
                metadata: foundObject ? foundObject.metadata : null,
                alldata: layer.metadata ? layer.metadata : null,
              });
            });
          }
          this.arcGisToken = arcgis.token;
          this.globals.enableLayers = this.arcGisLayers;
          this.globals.arcgisToken = this.arcGisToken;
        })
      ).subscribe();
    });
  }

  arcgicReconnect(): void {
    this.isSpinning = true;
    this._projectConfigsService.get().subscribe((response1)=>{
      const arcgisEnabled = this.globals.projectConfigs['services.integration.arcgis.enabled'];
      let userName: string;
      if (arcgisEnabled) {
        userName = this.globals.projectConfigs['services.integration.arcgis.username']
      } else {
        userName = this.globals.projectConfigs['services.integration.arcgis_enterprise.username']
      }
      this._projectConfigsService.getArcGISPrivilegesStatus(arcgisEnabled? 'arcgis' : 'arcgis_enterprise', {username: userName}).subscribe((response2)=>{
        this._projectConfigsService.get().subscribe(() => {
          this.applyArcgisStateFromConfig();
          this.isSpinning = false;
          this.cd.detectChanges();
          showFeedbackSaved();
        });
      })
    })
  }

  public updateSyncLayersForDisplay(): void {
    const state = (key: string) => this.syncLayerState[key] || {};
    const layers = this.updatedLayers?.layers ?? [];
    const config = this.globals.projectConfigs || {};
    const platform = this.activeArcGis;
    const list = layers.map((layer: any) => {
      const fromLayer = layer.error && String(layer.error).trim() ? layer.error : null;
      const fromConfig = config[`services.integration.${platform}.${layer.name}.error`] && String(config[`services.integration.${platform}.${layer.name}.error`]).trim();
      const rawError = fromLayer || fromConfig || null;
      const rawLayerInfo = this.parseLayerInfo(layer.layer_info);
      return {
        name: layer.name,
        labelKey: layer.name + '.labels',
        layer_name: layer.name+ '.label',
        error: rawError,
        layer_info: rawError ? null : rawLayerInfo,
        creating: !!state(layer.name).creating,
      };
    });
    this.syncLayersList = list;
    this.hasAnySyncLayerError = list.some((l) => !!l.error);
    const fromResponse = this.featureLayers?.service_error && String(this.featureLayers.service_error).trim();
    const fromConfig = this.globals.projectConfigs?.[`services.integration.${this.activeArcGis}.service.error`] && String(this.globals.projectConfigs[`services.integration.${this.activeArcGis}.service.error`]).trim();
    this.hasServiceError = !!(fromResponse || fromConfig);
  }

  private parseLayerInfo(layerInfo: any): { name: string; url: string; arcgis_link: string } | null {
    if (!layerInfo) return null;
    if (typeof layerInfo === 'object' && layerInfo.name) return layerInfo;
    if (typeof layerInfo === 'string') {
      try {
        const parsed = JSON.parse(layerInfo);
        return parsed && parsed.name ? parsed : null;
      } catch {
        return null;
      }
    }
    return null;
  }

  public trackBySyncLayerName(_index: number, layer: { name: string }): string {
    return layer.name;
  }

   /** ArcGIS content page link (organization content). */
  public readonly arcgisContentUrl = 'https://dialogarcgis.maps.arcgis.com/home/content.html';

  /** ArcGIS feature service name from services.integration.<platform>.stakeholders (URL like .../services/MFA/FeatureServer/5). */
  public get arcgisServiceInfo(): { name: string; url: string } | null {
    const rawUrl = this.globals.projectConfigs?.[`services.integration.${this.activeArcGis}.stakeholders`];
    if (!rawUrl || typeof rawUrl !== 'string') return null;
    const match = rawUrl.match(/\/services\/([^/]+)\/FeatureServer/i);
    if (!match) return null;
    return { name: match[1], url: this.arcgisContentUrl };
  }

  public openCreateNewLayerConfirm(layerKey: string): void {
    this.pendingLayerKey = layerKey;
    const itemName = this._transloco.translate(layerKey + '.labels');
    const message = this._transloco.translate('settings.arcgis.sync_layer_create_new_confirm_message', { itemName });
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, modalConfig({
      data: {
        title: this._transloco.translate('settings.arcgis.sync_layer_create_new_confirm_title'),
        message,
        cancelText: this._transloco.translate('settings.arcgis.sync_layer_cancel_btn'),
        confirmText: this._transloco.translate('settings.arcgis.sync_layer_create_layer_btn'),
      },
      panelClass: 'customized-dialog-container',
    }, ModalEnum.ModalSmall));
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      const key = this.pendingLayerKey;
      this.pendingLayerKey = null;
      if (key && confirmed) this.createNewSyncLayer(key);
      this.cd.detectChanges();
    });
  }

  public createNewSyncLayer(layerKey: string): void {
    this.syncLayerState[layerKey] = { ...(this.syncLayerState[layerKey] || {}), creating: true };
    this.updateSyncLayersForDisplay();
    this.cd.detectChanges();
    setTimeout(() => {
      const platform = this.activeArcGis;
      this._projectConfigsService.recreateArcGisLayer(platform, layerKey).subscribe({
        next: (res) => {
          const info = res.layer_info;
          const prefix = `services.integration.${platform}.${layerKey}`;
          if (this.globals.projectConfigs) {
            if (info) this.globals.projectConfigs[`${prefix}.layer_info`] = JSON.stringify(info);
            this.globals.projectConfigs[`${prefix}.error`] = '';
          }
          const layer = this.layerEntity?.find((l: any) => l.name === layerKey);
          if (layer) {
            layer.layer_info = info || layer.layer_info;
            layer.error = '';
          }
          this.syncLayerState[layerKey] = { ...(this.syncLayerState[layerKey] || {}), creating: false };
          this._projectConfigsService.get().subscribe(() => {
            this.applyArcgisStateFromConfig();
            this.updateSyncLayersForDisplay();
            this.cd.detectChanges();
          });
          showFeedbackSaved();
        },
        error: (err) => {
          this.syncLayerState[layerKey] = { ...(this.syncLayerState[layerKey] || {}), creating: false };
          this.updateSyncLayersForDisplay();
          this.cd.detectChanges();
          showFeedbackError(err);
        },
      });
    }, 0);
  }

  public openRecreateServiceConfirm(): void {
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, modalConfig({
      data: {
        title: this._transloco.translate('settings.arcgis.sync_layer_create_new_confirm_title'),
        message: this._transloco.translate('settings.arcgis.sync_layer_create_new_confirm_message'),
        cancelText: this._transloco.translate('settings.arcgis.sync_layer_cancel_btn'),
        confirmText: this._transloco.translate('settings.arcgis.sync_layer_create_layer_btn'),
      },
      panelClass: 'customized-dialog-container',
    }, ModalEnum.ModalSmall));
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) this.recreateService();
      this.cd.detectChanges();
    });
  }

  public recreateService(): void {
    this.recreatingService = true;
    this.cd.detectChanges();
    setTimeout(() => {
      const platform = this.activeArcGis;
      this._projectConfigsService.recreateArcGisService(platform).subscribe({
      next: () => {
        this._projectConfigsService.get().subscribe(() => {
          this.applyArcgisStateFromConfig();
          this.recreatingService = false;
          this.getFeaturesLayersFunction();
          this.cd.detectChanges();
          showFeedbackSaved();
        });
      },
      error: (err) => {
        this.recreatingService = false;
        this.cd.detectChanges();
        showFeedbackError(err);
      },
    });
    }, 0);
  }
}
